import { NgModule } from '@angular/core';
import { Routes, RouterModule, Router } from '@angular/router';
import { HomeComponent } from './components/home/home.component';
import { NosotrosComponent } from './components/nosotros/nosotros.component';
import { GaleriaComponent } from './components/galeria/galeria.component';
import { PremiocolaboraComponent } from './components/premiocolabora/premiocolabora.component';
import { PremioprincComponent } from './components/premioprinc/premioprinc.component';
import { RemanentesComponent } from './components/remanentes/remanentes.component';
//NO BORRAR
import { FormComponent } from './components/form/form.component';
import { ColaboraFormComponent } from './components/colabora-form/colabora-form.component';
import { ContactComponent } from './components/contact/contact.component';
import { ReglamentobecarioComponent } from './components/reglamentobecario/reglamentobecario.component';
import { PrivacidadComponent } from './components/privacidad/privacidad.component';
import { TerminosComponent } from './components/terminos/terminos.component';
import { ConvenioComponent } from './components/convenio/convenio.component';
import { BasesorteoComponent } from './components/basesorteo/basesorteo.component';
import { MecanicaComponent } from './components/mecanica/mecanica.component';
import { FaqsComponent } from './components/faqs/faqs.component';
import { DatesComponent } from './components/dates/dates.component';
import { RecuperarPassComponent } from './components/recuperar-pass/recuperar-pass.component';
import { MenuLoginComponent } from './components/menu-login/menu-login.component';
import { PostalComponent } from './components/postal/postal.component';
import { ComparteComponent } from './components/comparte/comparte.component';
import { ComparteTextComponent } from './components/comparte-text/comparte-text.component';
import { ConsultaBoletosComponent } from './components/consulta-boletos/consulta-boletos.component';
import { BlogComponent } from './components/blog/blog.component';
import { VentamesessininteresesComponent } from './components/ventamesessinintereses/ventamesessinintereses.component';
import { BasesoportunosComponent } from './components/basesoportunos/basesoportunos.component';
import { ParticiparSorteoOportunoComponent } from './components/participar-sorteo-oportuno/participar-sorteo-oportuno.component';

import { ThanksColaboradorComponent } from './components/thanks-colaborador/thanks-colaborador.component';
import { ThanksEgresadoComponent } from './components/thanks-egresado/thanks-egresado.component';

import { FormwinnersComponent } from './components/formwinners/formwinners.component';
import { LoginComponent } from './components/login/login.component';
import { FormularioDocumentosComponent } from './components/formulario-documentos/formulario-documentos.component';


// import { PuntosdeventaComponent } from './components/puntosdeventa/puntosdeventa.component';

import { ListaegresadosComponent } from './components/listaegresados/listaegresados.component';
import { GanadoressorteosoportunosComponent } from './components/ganadoressorteosoportunos/ganadoressorteosoportunos.component';
//import { GanadoresPrincipalesComponent } from './components/ganadores-principales/ganadores-principales.component';
import { ParticipantessorteoptComponent } from './components/participantessorteopt/participantessorteopt.component';
import { BasesegresadosComponent } from './components/basesegresados/basesegresados.component';
import { PuntosdeventaComponent } from './components/puntosdeventa/puntosdeventa.component';
import { Participantesso2Component } from './components/participantesso2/participantesso2.component';
import { MainloginComponent } from './components/mainlogin/mainlogin.component';
import { DocumentosComponent } from './components/documentos/documentos.component';
import { GalerianuevaComponent } from './components/galerianueva/galerianueva.component';
import { ParticipantesEgresadosComponent } from './components/participantes-egresados/participantes-egresados.component';
import { ParticipantesLealtadComponent } from './components/participantes-lealtad/participantes-lealtad.component';
import { ParticipantesAmigoComponent } from './components/participantes-amigo/participantes-amigo.component';
import { ParticipantesSONComponent } from './components/participantes-son/participantes-son.component';
import { Ganadorso2Component } from './components/ganadorso2/ganadorso2.component';
import { GanadorresegresadosComponent } from './components/ganadorresegresados/ganadorresegresados.component';
import { GanadorSo3Component } from './components/ganador-so3/ganador-so3.component';
import { GanadoresmagnoComponent } from './components/ganadoresmagno/ganadoresmagno.component';
import { BasesaniversarioComponent } from './components/basesaniversario/basesaniversario.component';
import { PremiosaniversarioComponent } from './components/premiosaniversario/premiosaniversario.component';
import { environment } from 'src/environments/environment';
import { EgresadosanivComponent } from './components/egresadosaniv/egresadosaniv.component';



const routes: Routes = [
    { path: 'home', component: HomeComponent },
    //{ path: 'sorteo-egresado-universidad-anahuac', component: EgresadosanivComponent },

    //{ path: 'sorteo-egresado-universidad-anahuac', component: ThanksEgresadoComponent },

    { path: 'premios-sorteo-anahuac', component: PremioprincComponent },
    { path: 'premios-para-colaboradores', component: PremiocolaboraComponent },
    { path: 'premios-sorteo-anahuac-aniversario', component: PremiosaniversarioComponent },

    //{ path: 'blog', component: BlogComponent },
    { path: 'contacto', component: ContactComponent },
    { path: 'preguntas-frecuentes', component: FaqsComponent },
    { path: 'fechas-importantes', component: DatesComponent },
    // { path: 'formulario-registro-colaboradores', component: ColaboraFormComponent },
    { path: 'nosotros', component: NosotrosComponent },
    { path: 'remanentes', component: RemanentesComponent },
    { path: 'mecanica', component: MecanicaComponent },
    { path: 'ganadores-sorteo', component: GaleriaComponent },
    { path: 'galeria', component: GalerianuevaComponent },

    //legales
    { path: 'aviso-de-privacidad', component: PrivacidadComponent },
    { path: 'carta-de-confidencialidad', component: ConvenioComponent },
    { path: 'reglamento-becario', component: ReglamentobecarioComponent },
    { path: 'terminos-y-condiciones', component: TerminosComponent },
    { path: 'bases-del-sorteo-magno', component: BasesorteoComponent },

    //{ path: 'bases-de-sorteos-oportunos', component: BasesoportunosComponent },

    { path: 'venta-meses-sin-intereses', component: VentamesessininteresesComponent },
    { path: 'sorteo-oportuno', component: ParticiparSorteoOportunoComponent },

    //{ path: 'puntos-de-venta', component: PuntosdeventaComponent },
    { path: 'puntos-de-venta', component: BasesoportunosComponent },
    { path: '**', redirectTo: 'home', pathMatch: 'full' },

    /*PASA LA VOZ */
    // { path: 'recuperar-contrasena', component: RecuperarPassComponent },
    // { path: 'menu-login', component: MenuLoginComponent },
    // { path: 'postal', component: PostalComponent },
    // { path: 'comparte', component: ComparteComponent },
    // { path: 'comparte-contenido', component: ComparteTextComponent },
    // { path: 'consulta-boletos', component: ConsultaBoletosComponent },


    // { path: 'formulario-registro-colaboradores-gracias', component: ThanksColaboradorComponent },
    /* FIN SORTEO */

    //{ path: 'lista-ganadores-sorteo-magno-2025', component: Ganadorso2Component },

    // { path: 'formulario-ganadores', component: FormwinnersComponent },
    // { path: 'login', component: LoginComponent },
    // { path: 'documentos-ganadores', component: DocumentosComponent },
    // { path: 'formulario-documentos', component: FormularioDocumentosComponent },
    // { path: 'login-ganadores', component: MainloginComponent },

    //{ path: 'bases-del-sorteo-aniversario', component: BasesaniversarioComponent },
    //{ path: 'bases-del-sorteo-egresados', component: BasesegresadosComponent },



    // { path: 'ganadores-sorteo-magno-novena-edicion', component:  GanadoresmagnoComponent },
    // { path: 'lista-ganadores-sorteo-magno-2025', component: ListaegresadosComponent },
    // { path: 'lista-participantes-tercer-sorteo-oportuno', component: Participantesso2Component },
    // { path: 'lista-participantes-sorteo-egresados-anahuac-2024', component: ParticipantesEgresadosComponent },
    // { path: 'lista-participantes-sorteo-egresados-lealtad-2024', component: ParticipantesLealtadComponent },
    // { path: 'lista-participantes-sorteo-egresados-amigo-referido-2024', component: ParticipantesAmigoComponent },
    // { path: 'lista-ganadores-sorteo-egresados-2024', component: GanadorresegresadosComponent },
    // { path: 'lista-participantes-primer-sorteo-oportuno', component: ParticipantessorteoptComponent },
    // { path: 'lista-ganadores-tercer-sorteo-oportuno-2025', component: GanadoressorteosoportunosComponent },
    //{ path: 'lista-ganadores-sorteo-magno-2025', component: ParticipantessorteoptComponent },
    //{ path: 'lista-ganadores-sorteo-aniversario', component: GanadorSo3Component },





];



@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule]
})
export class AppRoutingModule {

    link = "";
    link2: any;
    url = environment.URL_WEB;
    param_url: any;
    flag = false;
    constructor(private router: Router) {
        this.router.events.subscribe(async event => {
            if (event instanceof (await import('@angular/router')).NavigationEnd) {
                const navEndEvent = event as import('@angular/router').NavigationEnd;
                const url = navEndEvent.urlAfterRedirects || navEndEvent.url;
                if (url.includes('ganadores-sorteo') ||
                    url.includes('sorteo-egresado-universidad-anahuac') ||
                    url.includes('lista-ganadores-sorteo-aniversario') ||
                    url.includes('premios-sorteo-anahuac') ||

                    url.includes('aviso-de-privacidad') ||
                    url.includes('carta-de-confidencialidad') ||
                    url.includes('reglamento-becario') ||


                    url.includes('terminos-y-condiciones') ||
                    url.includes('bases-del-sorteo-magno') ||
                    url.includes('bases-del-sorteo-aniversario')||
                    url.includes('puntos-de-venta') 

                ) {
            // Oculta el submenú
            const subMenus = document.querySelectorAll('.sub-menu');
            subMenus.forEach(menu => {
                (menu as HTMLElement).style.display = 'none';
            });


        }
    }
});
    }

}




